// Hagen Jura KE 2 — Auslegung, Geschaeftsfaehigkeit, Form, Nichtigkeit, Anfechtung.
// Quelle: materials/markdown/hagen-jura-ke-02-bgb-at.md (gepruefte Lernfassung) + BGB.
// reviewStatus "reviewed": fachlich gegen Quelle geprueft; finale beta-ready-Freigabe durch Vincent.
const base = {
  mode: "hagen",
  ke: "hagen-ke-02",
  reviewStatus: "beta-ready",
};

const q = (exercise) => ({ ...base, ...exercise });

export const exercises = [
  q({
    id: "hagen-bgb-at2-001",
    topic: "KE 2 - Auslegung",
    kind: "single",
    level: 2,
    sources: ["bgb133", "bgb157", "hagenKe2"],
    title: "Massstab der Auslegung empfangsbeduerftiger Willenserklaerungen",
    prompt: "Wie ist eine empfangsbeduerftige Willenserklaerung auszulegen?",
    options: [
      { text: "So, wie der Empfaenger sie nach Treu und Glauben und der Verkehrssitte verstehen durfte (objektiver Empfaengerhorizont).", correct: true },
      { text: "Allein nach dem inneren, nicht geaeusserten Willen des Erklaerenden.", correct: false },
      { text: "Stets streng nach dem buchstaeblichen Wortlaut ohne Beruecksichtigung der Umstaende.", correct: false },
      { text: "Nach dem subjektiven Verstaendnis des Empfaengers, auch wenn es unvertretbar ist.", correct: false },
    ],
    explanation: "§§ 133, 157 BGB: Massgeblich ist der objektive Empfaengerhorizont. § 133 BGB verbietet das Haften am Buchstaben; § 157 BGB verlangt Auslegung nach Treu und Glauben mit Ruecksicht auf die Verkehrssitte.",
  }),

  q({
    id: "hagen-bgb-at2-002",
    topic: "KE 2 - Auslegung",
    kind: "single",
    level: 3,
    sources: ["bgb133", "hagenKe2"],
    title: "Falsa demonstratio",
    prompt: "Kaeufer und Verkaeufer bezeichnen die Ware uebereinstimmend als 'Haakjoeringskoed' (norwegisch fuer Haifisch), meinen aber beide Walfleisch. Geliefert werden soll Walfleisch. Worauf richtet sich der Vertrag?",
    options: [
      { text: "Auf Walfleisch - die uebereinstimmend gemeinte Sache; die gemeinsame Falschbezeichnung schadet nicht.", correct: true },
      { text: "Auf Haifischfleisch, weil der objektive Wortsinn der Bezeichnung massgeblich ist.", correct: false },
      { text: "Der Vertrag ist wegen Perplexitaet insgesamt nichtig.", correct: false },
      { text: "Der Vertrag ist schwebend unwirksam bis zur Klarstellung durch einen Dritten.", correct: false },
    ],
    explanation: "Falsa demonstratio non nocet: Meinen beide Parteien dasselbe, gilt das uebereinstimmend Gewollte, nicht der falsche Ausdruck (§ 133 BGB). Der Vertrag richtet sich auf Walfleisch. Auslegung geht der Anfechtung vor.",
  }),

  q({
    id: "hagen-bgb-at2-003",
    topic: "KE 2 - Auslegung",
    kind: "single",
    level: 2,
    sources: ["bgb157", "hagenKe2"],
    title: "Ergaenzende Vertragsauslegung",
    prompt: "Wann kommt eine ergaenzende Vertragsauslegung in Betracht?",
    options: [
      { text: "Bei einer planwidrigen Regelungsluecke, die nach dem hypothetischen Parteiwillen innerhalb des Vertragsprogramms zu schliessen ist.", correct: true },
      { text: "Immer dann, wenn eine Partei den Vertrag nachtraeglich fuer unguenstig haelt.", correct: false },
      { text: "Nur wenn beide Parteien einer Ergaenzung ausdruecklich zustimmen.", correct: false },
      { text: "Um eine bewusst offen gelassene Frage gegen den Willen der Parteien zu regeln.", correct: false },
    ],
    explanation: "Die ergaenzende Auslegung (§ 157 BGB) fuellt planwidrige Luecken anhand des hypothetischen Parteiwillens. Voraussetzung ist eine Luecke im Vertragsprogramm; eine bewusste Nichtregelung ist keine planwidrige Luecke.",
  }),

  q({
    id: "hagen-bgb-at2-004",
    topic: "KE 2 - Trennungs- und Abstraktionsprinzip",
    kind: "single",
    level: 2,
    sources: ["bgb433", "hagenKe2"],
    title: "Trennungsprinzip",
    prompt: "Was besagt das Trennungsprinzip?",
    options: [
      { text: "Verpflichtungsgeschaeft und Verfuegungsgeschaeft sind rechtlich selbststaendige Geschaefte.", correct: true },
      { text: "Verpflichtung und Verfuegung sind ein einheitliches Rechtsgeschaeft.", correct: false },
      { text: "Eine Verfuegung ist ohne vorheriges Verpflichtungsgeschaeft stets unwirksam.", correct: false },
      { text: "Nur Kaufleute koennen Verpflichtung und Verfuegung trennen.", correct: false },
    ],
    explanation: "Das Trennungsprinzip unterscheidet das schuldrechtliche Verpflichtungsgeschaeft (z. B. Kaufvertrag, § 433 BGB) von der dinglichen Verfuegung (z. B. Uebereignung). Beide sind eigenstaendige Rechtsgeschaefte.",
  }),

  q({
    id: "hagen-bgb-at2-005",
    topic: "KE 2 - Trennungs- und Abstraktionsprinzip",
    kind: "single",
    level: 3,
    sources: ["hagenKe2", "bgb"],
    title: "Abstraktionsprinzip im Fall",
    prompt: "Ein Kaufvertrag ueber eine Sache ist nichtig, die Sache wurde aber bereits uebereignet. Was folgt grundsaetzlich aus dem Abstraktionsprinzip?",
    options: [
      { text: "Die Uebereignung bleibt wirksam; rueckabgewickelt wird ueber das Bereicherungsrecht.", correct: true },
      { text: "Die Uebereignung ist automatisch ebenfalls nichtig.", correct: false },
      { text: "Der Kaufvertrag wird durch die Uebereignung rueckwirkend wirksam.", correct: false },
      { text: "Das Eigentum faellt ohne Weiteres an den Veraeusserer zurueck.", correct: false },
    ],
    explanation: "Nach dem Abstraktionsprinzip ist die Wirksamkeit der Verfuegung unabhaengig vom Verpflichtungsgeschaeft. Die Uebereignung bleibt wirksam; der Erwerber haelt das Eigentum ohne Rechtsgrund und gibt es ueber Bereicherungsrecht (§ 812 BGB) heraus.",
  }),

  q({
    id: "hagen-bgb-at2-006",
    topic: "KE 2 - Geschaeftsfaehigkeit",
    kind: "single",
    level: 1,
    sources: ["bgb104", "hagenKe2"],
    title: "Geschaeftsunfaehigkeit",
    prompt: "Wer ist nach dem Gesetz geschaeftsunfaehig?",
    options: [
      { text: "Wer nicht das siebente Lebensjahr vollendet hat.", correct: true },
      { text: "Jede Person unter 18 Jahren.", correct: false },
      { text: "Wer das 14. Lebensjahr noch nicht vollendet hat.", correct: false },
      { text: "Nur, wer unter Betreuung mit Einwilligungsvorbehalt steht.", correct: false },
    ],
    explanation: "§ 104 Nr. 1 BGB: Geschaeftsunfaehig ist, wer nicht das siebente Lebensjahr vollendet hat (sowie nach Nr. 2 bei dauerhafter freier Willensbestimmungsunfaehigkeit). Willenserklaerungen Geschaeftsunfaehiger sind nach § 105 BGB nichtig.",
  }),

  q({
    id: "hagen-bgb-at2-007",
    topic: "KE 2 - Geschaeftsfaehigkeit",
    kind: "single",
    level: 2,
    sources: ["bgb107", "hagenKe2"],
    title: "Lediglich rechtlicher Vorteil",
    prompt: "Der 10-jaehrige M erhaelt von seiner Tante eine Sache geschenkt (reine Schenkung, ohne Auflagen). Braucht er fuer die Annahme die Einwilligung seiner Eltern?",
    options: [
      { text: "Nein, das Geschaeft ist lediglich rechtlich vorteilhaft und daher ohne Einwilligung wirksam.", correct: true },
      { text: "Ja, jeder Vertrag eines Minderjaehrigen bedarf der Einwilligung.", correct: false },
      { text: "Ja, weil Schenkungen stets formbeduerftig und damit zustimmungspflichtig sind.", correct: false },
      { text: "Nein, weil M mit 10 bereits voll geschaeftsfaehig ist.", correct: false },
    ],
    explanation: "§ 107 BGB: Der beschraenkt Geschaeftsfaehige bedarf der Einwilligung nur fuer Geschaefte, die ihm nicht lediglich einen rechtlichen Vorteil bringen. Eine auflagenfreie Schenkung ist lediglich rechtlich vorteilhaft und damit ohne Einwilligung wirksam.",
  }),

  q({
    id: "hagen-bgb-at2-008",
    topic: "KE 2 - Geschaeftsfaehigkeit",
    kind: "single",
    level: 2,
    sources: ["bgb108", "hagenKe2"],
    title: "Schwebende Unwirksamkeit",
    prompt: "Ein beschraenkt Geschaeftsfaehiger schliesst ohne Einwilligung einen nicht lediglich vorteilhaften Vertrag. Wie ist die Rechtslage bis zur Entscheidung des gesetzlichen Vertreters?",
    options: [
      { text: "Der Vertrag ist schwebend unwirksam; er wird durch Genehmigung wirksam oder durch Verweigerung endgueltig unwirksam.", correct: true },
      { text: "Der Vertrag ist von Anfang an nichtig und kann nicht mehr wirksam werden.", correct: false },
      { text: "Der Vertrag ist sofort voll wirksam, die Eltern koennen nur Schadensersatz verlangen.", correct: false },
      { text: "Der Vertrag ist anfechtbar nach § 119 BGB.", correct: false },
    ],
    explanation: "§ 108 Abs. 1 BGB: Der ohne erforderliche Einwilligung geschlossene Vertrag ist schwebend unwirksam. Mit Genehmigung des gesetzlichen Vertreters wird er (rueckwirkend) wirksam, bei Verweigerung endgueltig unwirksam.",
  }),

  q({
    id: "hagen-bgb-at2-009",
    topic: "KE 2 - Geschaeftsfaehigkeit",
    kind: "single",
    level: 2,
    sources: ["bgb110", "hagenKe2"],
    title: "Taschengeldparagraph",
    prompt: "Welche Voraussetzung kennzeichnet § 110 BGB (Bewirken der Leistung mit eigenen Mitteln)?",
    options: [
      { text: "Der Minderjaehrige bewirkt die vertragsgemaesse Leistung mit Mitteln, die ihm zur freien Verfuegung ueberlassen wurden.", correct: true },
      { text: "Der Minderjaehrige darf jeden Vertrag schliessen, solange der Betrag gering ist.", correct: false },
      { text: "Der Vertrag wird bereits mit Abschluss wirksam, unabhaengig von der Zahlung.", correct: false },
      { text: "Die Eltern muessen jeder einzelnen Zahlung gesondert zustimmen.", correct: false },
    ],
    explanation: "§ 110 BGB: Ein ohne Einwilligung geschlossener Vertrag gilt als wirksam, wenn der Minderjaehrige die Leistung mit Mitteln bewirkt, die ihm zur freien Verfuegung oder zu diesem Zweck ueberlassen wurden. Erst das Bewirken (nicht schon der Abschluss) macht den Vertrag wirksam.",
  }),

  q({
    id: "hagen-bgb-at2-010",
    topic: "KE 2 - Form",
    kind: "single",
    level: 2,
    sources: ["bgb125", "hagenKe2"],
    title: "Folge des Formmangels",
    prompt: "Welche Rechtsfolge hat das Fehlen einer gesetzlich vorgeschriebenen Form grundsaetzlich?",
    options: [
      { text: "Das Rechtsgeschaeft ist nach § 125 BGB nichtig, sofern keine Heilung eingreift.", correct: true },
      { text: "Das Rechtsgeschaeft ist nur anfechtbar.", correct: false },
      { text: "Das Rechtsgeschaeft bleibt wirksam, es droht nur ein Bussgeld.", correct: false },
      { text: "Das Rechtsgeschaeft ist schwebend unwirksam bis zur behoerdlichen Genehmigung.", correct: false },
    ],
    explanation: "§ 125 Satz 1 BGB: Ein Rechtsgeschaeft, das der durch Gesetz vorgeschriebenen Form ermangelt, ist nichtig. In bestimmten Faellen ordnet das Gesetz eine Heilung an (z. B. § 311b Abs. 1 Satz 2 BGB bei Auflassung und Eintragung).",
  }),

  q({
    id: "hagen-bgb-at2-011",
    topic: "KE 2 - Form",
    kind: "single",
    level: 2,
    sources: ["bgb311b", "hagenKe2"],
    title: "Form des Grundstueckskaufvertrags",
    prompt: "Welche Form verlangt das Gesetz fuer einen Vertrag, durch den sich jemand zur Uebertragung eines Grundstuecks verpflichtet?",
    options: [
      { text: "Notarielle Beurkundung.", correct: true },
      { text: "Einfache Schriftform genuegt.", correct: false },
      { text: "Textform per E-Mail genuegt.", correct: false },
      { text: "Es besteht Formfreiheit.", correct: false },
    ],
    explanation: "§ 311b Abs. 1 Satz 1 BGB: Ein Vertrag, durch den sich ein Teil zur Uebertragung oder zum Erwerb eines Grundstuecks verpflichtet, bedarf der notariellen Beurkundung. Ein Formmangel fuehrt zur Nichtigkeit (§ 125 BGB), die durch Auflassung und Eintragung geheilt werden kann.",
  }),

  q({
    id: "hagen-bgb-at2-012",
    topic: "KE 2 - Nichtigkeit",
    kind: "single",
    level: 2,
    sources: ["bgb134", "hagenKe2"],
    title: "Verstoss gegen ein gesetzliches Verbot",
    prompt: "Was ist bei § 134 BGB zu pruefen, bevor man Nichtigkeit annimmt?",
    options: [
      { text: "Ob das verletzte Verbotsgesetz nach seinem Zweck die Nichtigkeit des Geschaefts verlangt.", correct: true },
      { text: "Ob beide Parteien die Sittenwidrigkeit kannten.", correct: false },
      { text: "Ob ein auffaelliges Missverhaeltnis von Leistung und Gegenleistung besteht.", correct: false },
      { text: "Ob die vorgeschriebene Form eingehalten wurde.", correct: false },
    ],
    explanation: "§ 134 BGB ordnet Nichtigkeit nur an, 'wenn sich nicht aus dem Gesetz ein anderes ergibt'. Massgeblich ist daher der Normzweck des Verbotsgesetzes: Nicht jeder Verstoss fuehrt zur Nichtigkeit des Rechtsgeschaefts.",
  }),

  q({
    id: "hagen-bgb-at2-013",
    topic: "KE 2 - Nichtigkeit",
    kind: "single",
    level: 3,
    sources: ["bgb138", "hagenKe2"],
    title: "Wucher",
    prompt: "Welche Voraussetzungen verlangt der Wuchertatbestand des § 138 Abs. 2 BGB?",
    options: [
      { text: "Ein auffaelliges Missverhaeltnis von Leistung und Gegenleistung und das Ausbeuten einer Schwaechelage (z. B. Zwangslage, Unerfahrenheit).", correct: true },
      { text: "Allein ein auffaelliges Missverhaeltnis von Leistung und Gegenleistung.", correct: false },
      { text: "Allein die Kenntnis einer Partei von der Geschaeftsunerfahrenheit der anderen.", correct: false },
      { text: "Ein Verstoss gegen eine behoerdliche Genehmigungspflicht.", correct: false },
    ],
    explanation: "§ 138 Abs. 2 BGB verlangt kumulativ ein objektives auffaelliges Missverhaeltnis und ein subjektives Element: das Ausbeuten einer Zwangslage, Unerfahrenheit, eines Mangels an Urteilsvermoegen oder einer erheblichen Willensschwaeche. Fehlt das subjektive Element, kann noch § 138 Abs. 1 BGB (wucheraehnliches Geschaeft) greifen.",
  }),

  q({
    id: "hagen-bgb-at2-014",
    topic: "KE 2 - Anfechtung",
    kind: "single",
    level: 3,
    sources: ["bgb119", "hagenKe2"],
    title: "Inhalts- oder Erklaerungsirrtum",
    prompt: "Wer sich ueber den objektiven Bedeutungsgehalt seiner Erklaerung irrt (er sagt bewusst, was er sagt, versteht aber etwas anderes darunter), unterliegt welchem Irrtum?",
    options: [
      { text: "Einem Inhaltsirrtum nach § 119 Abs. 1 Alt. 1 BGB.", correct: true },
      { text: "Einem Erklaerungsirrtum nach § 119 Abs. 1 Alt. 2 BGB.", correct: false },
      { text: "Einem unbeachtlichen Motivirrtum.", correct: false },
      { text: "Einem Eigenschaftsirrtum nach § 119 Abs. 2 BGB.", correct: false },
    ],
    explanation: "§ 119 Abs. 1 Alt. 1 BGB (Inhaltsirrtum): Der Erklaerende gibt zwar die gewollte Erklaerung ab, irrt aber ueber deren Bedeutung. Beim Erklaerungsirrtum (Alt. 2) verspricht/verschreibt er sich dagegen, will also schon das Erklaerungszeichen nicht.",
  }),

  q({
    id: "hagen-bgb-at2-015",
    topic: "KE 2 - Anfechtung",
    kind: "single",
    level: 2,
    sources: ["bgb119", "hagenKe2"],
    title: "Eigenschaftsirrtum",
    prompt: "Unter welchen Voraussetzungen berechtigt ein Irrtum ueber eine Eigenschaft einer Person oder Sache zur Anfechtung?",
    options: [
      { text: "Wenn die Eigenschaft im Verkehr als wesentlich angesehen wird (§ 119 Abs. 2 BGB).", correct: true },
      { text: "Bei jedem Irrtum ueber den Wert oder Preis der Sache.", correct: false },
      { text: "Nur bei arglistiger Taeuschung durch den Vertragspartner.", correct: false },
      { text: "Nie - der Eigenschaftsirrtum ist stets ein unbeachtlicher Motivirrtum.", correct: false },
    ],
    explanation: "§ 119 Abs. 2 BGB stellt den Irrtum ueber verkehrswesentliche Eigenschaften einer Person oder Sache dem Inhaltsirrtum gleich. Der blosse Irrtum ueber den Wert/Preis ist dagegen ein unbeachtlicher Motivirrtum.",
  }),

  q({
    id: "hagen-bgb-at2-016",
    topic: "KE 2 - Anfechtung",
    kind: "single",
    level: 3,
    sources: ["bgb123", "hagenKe2"],
    title: "Arglistige Taeuschung",
    prompt: "V verschweigt dem Kaeufer arglistig einen offenbarungspflichtigen Mangel. Welcher Anfechtungsgrund ist einschlaegig?",
    options: [
      { text: "Anfechtung wegen arglistiger Taeuschung nach § 123 Abs. 1 BGB.", correct: true },
      { text: "Anfechtung wegen Inhaltsirrtums nach § 119 Abs. 1 BGB.", correct: false },
      { text: "Anfechtung wegen Eigenschaftsirrtums nach § 119 Abs. 2 BGB.", correct: false },
      { text: "Keine Anfechtung; nur Ruecktritt vom Vertrag.", correct: false },
    ],
    explanation: "§ 123 Abs. 1 BGB: Wer durch arglistige Taeuschung zur Abgabe einer Willenserklaerung bestimmt wurde, kann anfechten. Auch das Verschweigen offenbarungspflichtiger Umstaende ist Taeuschung. § 123 BGB hat eine andere Wertung und laengere Frist als § 119 BGB.",
  }),

  q({
    id: "hagen-bgb-at2-017",
    topic: "KE 2 - Anfechtung",
    kind: "single",
    level: 2,
    sources: ["bgb121", "bgb124", "hagenKe2"],
    title: "Anfechtungsfristen",
    prompt: "Wie unterscheiden sich die Anfechtungsfristen bei Irrtum (§ 119 BGB) und bei arglistiger Taeuschung (§ 123 BGB)?",
    options: [
      { text: "Bei Irrtum unverzueglich nach Kenntnis (§ 121 BGB), bei Taeuschung/Drohung binnen eines Jahres (§ 124 BGB).", correct: true },
      { text: "In beiden Faellen gilt eine starre Frist von zwei Wochen.", correct: false },
      { text: "Bei Irrtum ein Jahr, bei Taeuschung unverzueglich.", correct: false },
      { text: "Beide Anfechtungen sind unbefristet moeglich.", correct: false },
    ],
    explanation: "§ 121 BGB: Die Irrtumsanfechtung muss ohne schuldhaftes Zoegern (unverzueglich) erfolgen. § 124 BGB: Die Anfechtung wegen Taeuschung oder Drohung ist binnen Jahresfrist ab Entdeckung bzw. Ende der Zwangslage moeglich.",
  }),

  q({
    id: "hagen-bgb-at2-018",
    topic: "KE 2 - Anfechtung",
    kind: "single",
    level: 2,
    sources: ["bgb142", "bgb122", "hagenKe2"],
    title: "Rechtsfolgen der Anfechtung",
    prompt: "Welche Rechtsfolgen hat eine wirksame Irrtumsanfechtung?",
    options: [
      { text: "Das Geschaeft ist als von Anfang an nichtig anzusehen (§ 142 BGB); der Anfechtende kann zum Ersatz des Vertrauensschadens verpflichtet sein (§ 122 BGB).", correct: true },
      { text: "Das Geschaeft wird nur fuer die Zukunft unwirksam, ein Schadensersatz ist ausgeschlossen.", correct: false },
      { text: "Das Geschaeft bleibt wirksam, der Anfechtende erhaelt lediglich Schadensersatz.", correct: false },
      { text: "Das Geschaeft ist schwebend unwirksam bis zur Bestaetigung durch den Gegner.", correct: false },
    ],
    explanation: "§ 142 Abs. 1 BGB: Das angefochtene Rechtsgeschaeft ist als von Anfang an (ex tunc) nichtig anzusehen. Bei der Irrtumsanfechtung schuldet der Anfechtende nach § 122 BGB den Vertrauensschaden (negatives Interesse), begrenzt auf das positive Interesse.",
  }),
];
